import {
  Button,
  NavBar,
  Row,
  Col,
  Tag,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Swipe,
  Toast,
  SwipeItem,
  SubmitBar,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn
} from 'vant';

import ImgUserStage from './img-user-stage.vue';
import WzNavbar from './wz-navbar.vue';
import TimerNum from './timer/num.vue';
import TimerText from './timer/text.vue';
import ButtonBuy from './goods-button-buy.vue';
// import GoodsItemBig from './goods-item-big.vue';
import Goods404 from './goods/404.vue';
import DetailHeadTimer from './detail/head-timer.vue';
// import DetailHead from './detail/head.vue';
// import DetailBodyPre from './detail/body-pre.vue';
// import DetailBodyLast from './detail/body-last.vue';

import GoodsStatus from './goods/status.vue';
import GoodsPreStatus from './goods/pre-status.vue';
import GoodsLastStatus from './goods/last-status.vue';
import GoodsTop from './goods/top.vue';

import RuleText from './rule-text.vue';
import QRCode from './qr-code.vue';

// import GoodsSatusPre from './goods-item-pre.vue';
// import GoodsSatusLast from './goods-item-last.vue';
// import GoodsItem11 from './goods-item-11.vue';
// import GoodsItem12 from './goods-item-12.vue';
// import GoodsItem2x from './goods-item-2x.vue';
// import Goods11 from './goods-11.vue';
// import Goods12 from './goods-12.vue';
// import Goods21 from './goods-21.vue';
// import Goods22 from './goods-22.vue';
// import Goods23 from './goods-23.vue';


export default (Vue) => {
  function register(O) {
    for (const name in O) {
      if (O.hasOwnProperty(name)) {
        Vue.component(name, O[name])
      }
    }
  }
  register({
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Dialog.name]: Dialog,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionBigBtn.name]: GoodsActionBigBtn,
    [GoodsActionMiniBtn.name]: GoodsActionMiniBtn,
    [SubmitBar.name]: SubmitBar,
    [NavBar.name]: NavBar,
    'img-user-stage': ImgUserStage,
    'timer-text': TimerText,
    'wz-navbar': WzNavbar,
    'timer-num': TimerNum,
    'goods-button-buy': ButtonBuy,
    'detail-head-timer': DetailHeadTimer,
    'goods-404': Goods404,
    'goods-top': GoodsTop,
    'rule-text': RuleText,
    'goods-status': GoodsStatus, // 商品状态
    'goods-pre-status': GoodsPreStatus, // 预售商品状态
    'goods-last-status': GoodsLastStatus, // 尾款商品状态
    'qr-code': QRCode
  })
  // Vue.component(NavBar.name, NavBar)
  // Vue.component(Row.name, Row)
  // Vue.component(Col.name, Col)
  // Vue.component(Tag.name, Tag)
  // Vue.component(Icon.name, Icon)
  // Vue.component(Toast.name, Toast)
  // Vue.component(Cell.name, Cell)
  // Vue.component(CellGroup.name, CellGroup)
  // Vue.component(Swipe.name, Swipe)
  // Vue.component(SwipeItem.name, SwipeItem)
  // Vue.component(SwipeItem.name, SwipeItem)
  // Vue.component(Dialog.name, Dialog)

  // Vue.component(GoodsAction.name, GoodsAction)
  // Vue.component(GoodsActionBigBtn.name, GoodsActionBigBtn)
  // Vue.component(GoodsActionMiniBtn.name, GoodsActionMiniBtn)
  // Vue.component(SubmitBar.name, SubmitBar)

  // Vue.component('img-user-stage', ImgUserStage)
  // Vue.component('timer-text', TimerText)
  // Vue.component('wz-navbar', WzNavbar)
  // Vue.component('timer-num', TimerNum)
  // Vue.component('goods-button-buy', ButtonBuy)
  // Vue.component('detail-head-timer', DetailHeadTimer)
  // Vue.component('goods-404', Goods404)
  // Vue.component('goods-top', GoodsTop)
  // Vue.component('rule-text', RuleText)

  // Vue.component('goods-status', GoodsStatus) // 商品状态
  // Vue.component('goods-pre-status', GoodsPreStatus) // 预售商品状态
  // Vue.component('goods-last-status', GoodsLastStatus) // 尾款商品状态
  // Vue.component('qr-code', QRCode)

  // Vue.component('detail-head', DetailHead)
  // Vue.component('detail-body-pre', DetailBodyPre)
  // Vue.component('detail-body-last', DetailBodyLast)
  // Vue.component('goods-item-big', GoodsItemBig)



  // Vue.component('goods-item-11', GoodsItem11)
  // Vue.component('goods-item-12', GoodsItem12)
  // Vue.component('goods-item-2x', GoodsItem2x)

  // 商品详情
  // Vue.component('goods-11', Goods11)
  // Vue.component('goods-12', Goods12)
  // Vue.component('goods-21', Goods21)
  // Vue.component('goods-22', Goods22)
  // Vue.component('goods-23', Goods23)
}
